import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { TransactionDeals } from '../shared/models/transaction-deals/transaction-deal';
import { Router } from '@angular/router';
import { Transaction } from '../shared/models/transactions/transaction';

@Injectable({
  providedIn: 'root',
})
export class TransactionDealService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/transactiondeal/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public GetDealByTransactionId(transactionId: number): Observable<TransactionDeals> {
    return this.http.get<TransactionDeals>(`${this.apiUrl}${transactionId}`);
  }

  public UpdateDealAndTransactionStatus(transaction: Transaction): Observable<Transaction> {
    return this.http
      .put<Transaction>(`${this.apiUrl}status`, transaction, {
        observe: 'response',
      })
      .pipe(map((response) => response.body));
  }
}
